import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { PagesComponent } from "./pages/pages.component";
import { LoginComponent } from "./login/login.component";
import { RecoveryPasswordComponent } from "./recovery-password/recovery-password.component";
import { ChangePasswordComponent } from "./change-password/change-password.component";
import { RouteTranslatedInterface, routingTranslated } from "./routes";
import { mockData } from "../mockData";

let routes: Routes = [
  {
    path: "",
    component: PagesComponent,

    children: [],
  },
  { path: "login", component: LoginComponent },
  { path: "recupero-password", component: RecoveryPasswordComponent },
  { path: "cambia-password", component: ChangePasswordComponent },
  { path: "recovery-password", component: RecoveryPasswordComponent },
  { path: "change-password", component: ChangePasswordComponent },
];

routingTranslated.forEach((route: RouteTranslatedInterface) => {
  route.paths.forEach((path: string, index) => {
    if (routes[0].children) {
      let myData = {
        ...route.data,
        breadcrumb: route.data.breadcrumb.map((b: any) => ({ ...b })),
      };
      myData.breadcrumb[route.breadcrumbIndex].route = path;
      myData.breadcrumb[route.breadcrumbIndex].title = route.titles[index];
      myData.currentElement = route.breadcrumbIndex;
      myData.mockData = mockData
      routes[0].children.push({
        path: path,
        component: route.component,
        data: myData,
      });
    }
  });
});

@NgModule({
  imports: [RouterModule.forRoot(routes, { bindToComponentInputs: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
